export const CREDIT_BLOTTER_PREFIX = 'credits-v2'; // this was bumped from "credits" to "credits-v2" as of 2.44
